module.exports = __webpack_public_path__ + "kudos_16.svg?94ae906d0db4cad9172fce52d38e098d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_16.svg
// module id = 113
// module chunks = 0